import React, { Fragment, useState } from "react"
import { useInputValue } from "../../hooks/useInputValue"
import {
  Error,
  Success,
  Form,
  Input,
  Title,
  Paragraph,
  Section,
  Container,
} from "./styles"
import { SubmitButton } from "../SubmitButton"
const axios = require("axios").default

export const ContactForm = ({ title, paragraph }) => {
  const nombre = useInputValue("")
  const email = useInputValue("")
  const ciudad = useInputValue("")
  const [isSent, setIsSent] = useState(false)
  const [errorMsg, setErrorMsg] = useState(false)
  const [disabled, setDisabled] = useState(false)

  const handleSubmit = event => {
    event.preventDefault()
    const input = {
      nombre: nombre.value,
      email: email.value,
      ciudad: ciudad.value,
    }
    console.log(input)
    axios
      .post("https://yanadrover.now.sh/api/", input)
      .then(res => {
        setIsSent(true)
        setDisabled(true)
      })
      .catch(() => {
        console.log("Message not sent")
        setErrorMsg("ha ocurrido un error")
      })
  }

  return (
    <Fragment>
      <Section>
        <Container>
          <Form disabled={disabled} onSubmit={handleSubmit}>
            <Title>{title}</Title>
            <Paragraph>{paragraph}</Paragraph>
            <Input disabled={disabled} placeholder="Nombre" {...nombre} />
            <Input disabled={disabled} placeholder="Email" {...email} />
            <Input disabled={disabled} placeholder="Ciudad" {...ciudad} />
            <SubmitButton disabled={disabled}>Enviar</SubmitButton>
          </Form>
          {isSent && <Success>Enviado</Success>}
          {errorMsg && <Error>{errorMsg}</Error>}
        </Container>
      </Section>
    </Fragment>
  )
}
